import { useMutation } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

type BreakDownResult =
  | { type: "subtasks"; subtasks: string[] }
  | { type: "questions"; questions: string[] };

export function useBreakDown() {
  return useMutation({
    mutationFn: async (input: {
      item_id: string;
      mode: "quick" | "think";
      user_context?: string;
    }): Promise<BreakDownResult> => {
      const { data, error } = await supabase.functions.invoke("break-down-item", {
        body: input,
      });
      if (error) throw error;
      return data as BreakDownResult;
    },
  });
}
